import React from "react";
import styled from "styled-components";
import { colors } from "../../../../utils/theme";
import { useNavigate } from "react-router-dom";

import {
  IPatientOrderServiceContex,
  Order,
  IPatientInfo,
} from "../../../../interfaces/Patient";
import { log } from "console";

const Container = styled.div`
  width: 100%;
  .form {
    border-bottom: 1px solid #00000029;
    padding: 1rem 0;
    width: 95%;
    margin: 0 auto;
  }
  .NoHayOrdenes {
    text-align: center;
    color: #857b7b;
  }

  .ContenedorNoHayOrdenes {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 2rem;
    padding: 1rem;
  }
`;

const ContainerFormInfo = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  justify-content: center;
`;
const FormInputInfo = styled.div`
  width: 25%;
  display: flex;
  gap: 20px;
  flex-direction: column;

  @media (max-width: 1440px) {
    width: 30%;
  }
  @media (max-width: 768px) {
    width: 45%;
  }
  @media (max-width: 500px) {
    width: 90%;
  }

  label {
    width: 100%;
    color: ${colors.third};
    font-weight: 600;
    @media (max-width: 1024px) {
      text-align: start;
    }
  }

  input {
    width: 80%;
    height: 40px;
    border: 1px solid #d9d9d9;
    padding-left: 10px;
    color: ${colors.fifth};
    @media (max-width: 500px) {
      width: 100%;
    }
    &::placeholder {
      color: ${colors.fifth};
    }
  }
`;

const ContainerButton = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 2rem;
  .button {
    width: 20%;
    display: block;
    padding: 0.7rem;
    border: none;
    border-radius: 30px;
    color: ${colors.blanco};
    background-color: ${colors.azul};
    margin-bottom: 2rem;
    font-weight: bold;
    text-decoration: none;
    text-align: center;
    @media (max-width: 1440px) {
      width: 32%;
    }
    @media (max-width: 1024px) {
      width: 40%;
    }
    @media (max-width: 768px) {
      width: 50%;
    }
    @media (max-width: 600px) {
      width: 80%;
    }
    @media (max-width: 350px) {
      font-size: 0.8rem;
    }
  }
`;

const OrderForm = ({ data }: { data: IPatientInfo | null }) => {
  const patient = {
    name: data?.name,
    email: data?.email,
    numeroDocumento: data?.numeroDocumento,
    tipoDocumento: data?.tipoDocumento,
    telefono: data?.telefono,
    fechaNacimiento: data?.fechaNacimiento,
  };
  

  return (
    <Container>
      {data?.orders[0]?.sesiones.length > 0 && (
        <SingleOrderForm order={data?.orders[0]} patient={patient} />
      )}
      {data?.sesionesSinOrden?.sesiones.length > 0 && (
        <SingleOrderForm order={data?.sesionesSinOrden} patient={patient} />
      )}
    </Container>
  );
};

const SingleOrderForm = ({ order, patient }) => {
  const navigate = useNavigate();

  const handleInputChange = (newValue) => {
    console.log("");
  };

  const handleViewSessions = (e, order, patient) => {
    e.preventDefault();
    const PatientOrderSession: IPatientOrderServiceContex = {
      name: patient.name,
      numeroDocumento: patient.numeroDocumento,
      tipoDocumento: patient.tipoDocumento,
      fechaNacimiento: patient.fechaNacimiento,
      email: patient.email,
      telefono: patient.telefono,
      orders: order,
    };

    

    // console.log(PatientOrderSession);

    navigate("/Sesiones", { state: { PatientOrderSession } });
    // console.log(order);
  };

  const isNotoOrder = order.orden === "0";
  console.log(isNotoOrder, "isNotoOrder");

  return (
    <form
      className="form"
      onSubmit={(e) => handleViewSessions(e, order, patient)}
    >
      {isNotoOrder ? (
        <div className="ContenedorNoHayOrdenes">
          <h4 className="NoHayOrdenes">
            Las sesiones actuales no tienen una orden médica asociada y se
            considerarán bajo un nuevo diagnóstico. Aún no se ha emitido un
            diagnóstico oficial por parte del centro de fisioterapia Mi Físico.
            Pese a ello, se tiene la flexibilidad de cancelar cualquier sesión
            si lo consideras necesario. Para hacerlo, simplemente selecciona la
            opción “CANCELAR SESIÓN SIN ORDEN”.
          </h4>
        </div>
      ) : (
        <ContainerFormInfo>
          <FormInputInfo>
            <label>ÁREA AFECTADA</label>
            <input
              type="text"
              value={order.areaAfectada}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>NO. DE ORDEN</label>
            <input
              type="text"
              value={order.numeroDeOrden}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>AUTORIZACIÓN</label>
            <input
              type="text"
              value={order.autorizacion}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>SESIONES AUTORIZADAS</label>
            <input
              type="text"
              value={order.sesionesAutorizadas}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>
          <FormInputInfo>
            <label>SESIONES REALIZADAS</label>
            <input
              type="text"
              value={order.sesionesRealizadas}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>ENTIDAD</label>
            <input
              type="text"
              value={order.entidad}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>MÉDICO REMITENTE</label>
            <input
              type="text"
              value={order.medicoRemitente}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>

          <FormInputInfo>
            <label>FECHA</label>
            <input
              type="text"
              value={order.fechaInicioTratamiento}
              onChange={(e) => handleInputChange(e.target.value)}
            />
          </FormInputInfo>
        </ContainerFormInfo>
      )}

      <ContainerButton>
        <button className="button" type="submit">
          {isNotoOrder
            ? "CANCELAR SESIÓN SIN ORDEN"
            : "VER PRÓXIMAS CITAS AGENDADAS"}
        </button>
      </ContainerButton>
    </form>
  );
};

export default OrderForm;
